module.exports = __webpack_public_path__ + "static/openlaw1-4f38116d196b73991c66f78e041d510b.svg";